<template>
    <div>
        <PageTitle :title="$t('renovar_base.titulo', { temporada: lista_abonados.nombre })" class="strech"/>
        <RenovarBase/>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import RenovarBase from "@/components/frontend/bases/renovar/RenovarBase";

    export default {
        created() {
            if(!this.footer.renovacion_futbol_base || this.footer.ocultar_renovacion_futbol_base  || this.footer.activar_compra_por_invitacion_bases && localStorage.getItem('codigo_invitacion') == null) {
                this.$router.push({ name: 'front.home'});
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
        components: { PageTitle, RenovarBase }
    }
</script>